<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Benutzer bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="update">
                <form-fields :form="form" :user="user" :countries="countries" :accounts="accounts" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'user',
            'accounts',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'put',
                    account_id: this.user.account_id,
                    salutation: this.user.salutation,
                    title: this.user.title,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    notes: this.user.notes,
                    avatar: null,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
            update() {
                this.form.post(this.route('admin.users.update', this.user), {
                    onSuccess: () => this.form.reset('password', 'avatar'),
                });
            }
        },
    }
</script>